export const YORM_LOGO_URL = "https://customer-assets.emergentagent.com/job_e194f4c5-8d32-4ac0-8243-34dcb9b16c4c/artifacts/i9igc7w1_FBABBFB0-B86A-40AF-A319-0D7428AF7412.png";
